import { BarceloComponent } from "components-utils";

const TeasersComponents = {
  advantagesCards: BarceloComponent({
    selector: ".advantages-cards",
    path: "barcelo/teasers/advantages-cards/js/advantages-cards",
  }),

  infoServicePage: BarceloComponent({
    selector: ".info-service__wrapper, .c-info-service",
    path: "barcelo/teasers/info-service-page/js/info-service-page",
  }),

  teaserHotelCard: BarceloComponent({
    selector: ".c-hotel-card",
    path: "barcelo/teasers/hotel-card/js/teaser-hotel-card",
  }),

  carousel: BarceloComponent({
    selector: ".cmp-bhg-carousel",
    path: "barcelo/teasers/carousel/js/c-carousel",
  }),

  coupon: BarceloComponent({
    selector: ".c-coupon, .c-coupon-compact__promo, .c-coupon-compact__active",
    path: "barcelo/teasers/coupon/js/c-coupon",
  }),

  servicesCarousel: BarceloComponent({
    selector: ".c-services-carousel",
    path: "barcelo/teasers/services-carousel-cards/js/c-services-carousel-cards",
  }),

  card: BarceloComponent({
    selector: [".c-card", ".text-desktop-JS", ".text-mobile-JS"],
    path: "barcelo/teasers/card/js/c-card",
  }),

  cardHotelServices: BarceloComponent({
    selector: ".c-card-hotel-services, .c-card-hotel-services__card",
    path: "barcelo/teasers/card-hotel-service/js/c-card-hotel-services",
  }),

  launcher: BarceloComponent({
    selector: ".launcher, .c-launcher, .JS-c-launcher-link",
    path: "barcelo/teasers/launcher/js/c-launcher",
  }),

  menuCards: BarceloComponent({
    selector: ".menu-cards",
    path: "barcelo/teasers/menu-cards/js/menu-cards",
  }),

  experienceCards: BarceloComponent({
    selector: ".experience-cards",
    path: "barcelo/teasers/experience-cards/js/experience-cards",
  }),

  gallerySummary: BarceloComponent({
    selector: ".c-gallery-summary",
    path: "barcelo/teasers/gallery-summary/js/c-gallery-summary",
  }),

  collectionCarouselHotels: BarceloComponent({
    selector: ".collection-carousel__wrapper",
    path: "barcelo/teasers/collection-carousel-hotels/js/collection-carousel-hotels",
  }),

  fourNewsCarousel: BarceloComponent({
    selector: ".four-news_new-dl-id",
    path: "barcelo/teasers/four-news-carousel/js/four-news-carousel",
  }),

  collectionCarouselList: BarceloComponent({
    selector: ".collection-carousel-list__wrapper",
    path: "barcelo/teasers/collection-carousel-list/js/collection-carousel-list",
  }),
};

export default TeasersComponents;
